import { InfiniteListBase } from "ra-core";
import type { Identifier } from "ra-core";

import { ActivityLogContext } from "./ActivityLogContext";
import { ActivityLogIterator } from "./ActivityLogIterator";

type ActivityLogProps = {
  companyId?: Identifier;
  pageSize?: number;
  context?: "company" | "contact" | "deal" | "all";
  /**
   * Extra data-provider filter, merged after the company one. Used by the
   * dashboard to narrow the feed down to an account manager or to a subset of
   * activity types.
   */
  filter?: Record<string, unknown>;
};

export function ActivityLog({
  companyId,
  pageSize = 20,
  context = "all",
  filter,
}: ActivityLogProps) {
  return (
    <ActivityLogContext.Provider value={context}>
      <InfiniteListBase
        resource="activity_log"
        filter={{ ...(companyId ? { company_id: companyId } : {}), ...filter }}
        sort={{ field: "date", order: "DESC" }}
        perPage={pageSize}
        disableSyncWithLocation
      >
        <ActivityLogIterator />
      </InfiniteListBase>
    </ActivityLogContext.Provider>
  );
}
